//./react-app/src/scenes/dashboard/index.tsx
import Header from '../../components/Header';
import { FC, useState } from 'react';
import { Box, useTheme, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { tokens } from '../../theme';
import NewsletterStatistics from '../../components/NewsletterStatistics';
import NewsletterStatisticsDual from '../../components/NewsletterStatisticsDual';

const Newsletter: FC = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [viewMode, setViewMode] = useState<'mailchimp' | 'dual'>('dual');

  const handleViewModeChange = (
    event: React.MouseEvent<HTMLElement>,
    newMode: 'mailchimp' | 'dual' | null,
  ) => {
    if (newMode !== null) {
      setViewMode(newMode);
    }
  };

  return (
    <Box m="20px">
      <Box justifyContent="space-between" alignItems="center" display="flex">
        <Header title="Newsletter" subtitle="Aggregierte Kampagnenstatistik" />
        <ToggleButtonGroup
          value={viewMode}
          exclusive
          onChange={handleViewModeChange}
          aria-label="view mode"
        >
          <ToggleButton value="mailchimp" aria-label="mailchimp only">
            Nur Mailchimp
          </ToggleButton>
          <ToggleButton value="dual" aria-label="dual esp">
            Dual ESP (Mailchimp + Iterable)
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
      <Box display="grid" gridTemplateColumns="1fr" gap="20px">
        <Box sx={{ backgroundColor: colors.primary[400] }}>
          <Box height="250px" mt="-20px">
            {viewMode === 'mailchimp' ? <NewsletterStatistics /> : <NewsletterStatisticsDual />}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Newsletter;
